import Vue from "vue";
import VueRouter from "vue-router";

// Layout
import Layout from "@/layout";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Layout,
    redirect: "categories",
    children: [
      {
        path: "categories",
        component: () => import("@/views/category/index"),
        name: "ManageCategory",
        meta: {
          title: "Quản lý danh mục bài viết",
          icon: "el-icon-menu",
          affix: true,
        },
      },
    ],
  },
  {
    path: "/postses",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/posts/index"),
        name: "ManagePosts",
        meta: {
          title: "Quản lý bài viết",
          icon: "el-icon-document",
          affix: false,
        },
      },
    ],
  },
  {
    path: "/podcasts",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/podcast/index"),
        name: "ManagePodcast",
        meta: {
          title: "Quản lý podcast",
          icon: "el-icon-video-camera-solid",
          affix: false,
        },
      },
    ],
  },
  {
    path: "/feedbacks",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/feedback/index"),
        name: "Feedback",
        meta: {
          title: "Quản lý feedback",
          icon: "el-icon-message",
          affix: false,
        },
      },
    ],
  },
  {
    path: "/need-advise",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/needAdvise/index"),
        name: "Advise",
        meta: {
          title: "Quản lý Advise",
          icon: "el-icon-chat-line-square",
          affix: false,
        },
      },
    ],
  },
  {
    path: "/subscribe",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/subscribe/index"),
        name: "Subscribe",
        meta: {
          title: "Quản lý subscribe",
          icon: "el-icon-s-flag",
          affix: false,
        },
      },
    ],
  },
  {
    path: "/banners",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/banner/index"),
        name: "ManageBanner",
        meta: {
          title: "Quản lý banner",
          icon: "el-icon-picture",
          affix: false,
        },
      },
    ],
  },
  {
    path: "/podcast",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "create",
        component: () => import("@/views/podcast/manage"),
        name: "CreatePodcast",
        meta: {
          title: "Thêm mới podcast",
        },
      },
      {
        path: "update/:id",
        component: () => import("@/views/podcast/manage"),
        name: "UpdatePodcast",
        meta: {
          title: "Cập nhật podcast",
        },
      },
    ],
  },
  {
    path: "/banner",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "create",
        component: () => import("@/views/banner/manage"),
        name: "CreateBanner",
        meta: {
          title: "Tạo mới banner",
        },
      },
      {
        path: "update/:id",
        component: () => import("@/views/banner/manage"),
        name: "UpdateBanner",
        meta: {
          title: "Cập nhật banner",
        },
      },
    ],
  },
  {
    path: "/posts",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "create",
        component: () => import("@/views/posts/manage"),
        name: "CreatePosts",
        meta: {
          title: "Thêm mới bài viết",
        },
      },
      {
        path: "update/:id",
        component: () => import("@/views/posts/manage"),
        name: "UpdatePosts",
        meta: {
          title: "Cập nhật bài viết",
        },
      },
    ],
  },
  {
    path: "/category",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "create",
        component: () => import("@/views/category/manage"),
        name: "CreateCategory",
        meta: {
          title: "Tạo danh mục bài viết",
        },
      },
      {
        path: "update/:id",
        component: () => import("@/views/category/manage"),
        name: "UpdateCategory",
        meta: {
          title: "Cập nhật danh mục bài viết",
        },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login.vue"),
    hidden: true,
    meta: {
      title: "Đăng nhập",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
